import { DynamicStateDisplay } from "../../DymanicStateDisplay/DymanicStateDisplay"

export const SubcontractStateRender = (params: any) => {
    const name = params?.row?.contractConcessionOrganizationState?.name
    const color = params?.row?.contractConcessionOrganizationState?.color
    const backgroundColor = params?.row?.contractConcessionOrganizationState?.backgroundColor
    return (
        <DynamicStateDisplay name={name} color={color} backgroundColor={backgroundColor} />
    )
}
